import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import myinfoIcon from '../../asset/img/main_header_myinfo_icon.svg';
import logoIcon from '../../asset/img/common/logo.svg';
import MyInfo from '../../features/myInfo';

const HeaderStyled = styled.div`
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  background-color: #fff;
  position: sticky;
  top: 0;
  z-index: 100;
`;

const MainHeader = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('login');
  const [isMyInfoOpen, setIsMyInfoOpen] = useState(false);

  const handleMyInfoClick = () => {
    setIsMyInfoOpen(true);
  };

  const handleMyInfoClose = () => {
    setIsMyInfoOpen(false);
  };

  return (
    <HeaderStyled>
      <img src={logoIcon} alt="logo" />
      <div>
        <img src={myinfoIcon} alt="내정보" onClick={handleMyInfoClick} />
      </div>
      <MyInfo isOpen={isMyInfoOpen} onClose={handleMyInfoClose} />
    </HeaderStyled>
  );
};

export default MainHeader;
